"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _filterProps = require("../../../internal/filterProps");
var _tokens = require("../../../tokens");
var _constants = require("../constants");
var _responsiveProps = require("../../../internal/responsiveProps");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const DEFAULT_PROPS = {
  ext: 'png',
  formatPath: _ref => {
    let {
      path,
      ext,
      width
    } = _ref;
    return `${_constants.CLOUDINARY_ROOT_PATH}/c_scale,f_auto,q_auto,w_${width}/${path}.${ext}`;
  }
};
const StyledImage = (0, _styledComponents.default)(ownProps => {
  const {
    formatPath,
    pathFromS,
    pathFromM,
    pathFromL,
    pathFromXL,
    ext: extProp,
    widthFromS,
    widthFromM,
    widthFromL,
    widthFromXL,
    role,
    alt,
    ...props
  } = Object.assign({}, DEFAULT_PROPS, ownProps);
  const extArr = typeof extProp === 'string' ? [extProp] : extProp;
  const getSrc = function (breakpoint, widthMultiplier) {
    let ext = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : extArr[extArr.length - 1];
    return formatPath({
      ext,
      path: (0, _responsiveProps.getResponsivePropValue)(ownProps, 'path', breakpoint),
      width: (0, _responsiveProps.getResponsivePropValue)(ownProps, 'width', breakpoint) * widthMultiplier
    });
  };
  const filteredProps = (0, _filterProps.filterProps)({
    props,
    keys: ['width', 'stretch']
  });
  const Sources = _ref2 => {
    let {
      breakpoint,
      media
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, extArr.map(ext => /*#__PURE__*/_react.default.createElement("source", {
      type: _constants.IMAGE_TYPES[ext],
      key: `${ext}-${breakpoint}`,
      srcSet: `
            ${getSrc(breakpoint, 1, ext)} 1x,
            ${getSrc(breakpoint, 2, ext)} 2x
          `,
      media: media
    })));
  };
  return /*#__PURE__*/_react.default.createElement("picture", null, (widthFromXL || pathFromXL) && /*#__PURE__*/_react.default.createElement(Sources, {
    breakpoint: "XL",
    media: `(min-width: ${_tokens.BREAKPOINT.L}px)`
  }), (widthFromL || pathFromL) && /*#__PURE__*/_react.default.createElement(Sources, {
    breakpoint: "L",
    media: `(min-width: ${_tokens.BREAKPOINT.M}px)`
  }), (widthFromM || pathFromM) && /*#__PURE__*/_react.default.createElement(Sources, {
    breakpoint: "M",
    media: `(min-width: ${_tokens.BREAKPOINT.S}px)`
  }), (widthFromS || pathFromS) && /*#__PURE__*/_react.default.createElement(Sources, {
    breakpoint: "S",
    media: `(min-width: ${_tokens.BREAKPOINT.XS}px)`
  }), /*#__PURE__*/_react.default.createElement("source", {
    srcSet: `
          ${getSrc(null, 1)} 1x,
          ${getSrc(null, 2)} 2x
        `
  }), /*#__PURE__*/_react.default.createElement("img", _extends({
    src: getSrc(null, 1),
    role: role ? role : alt ? undefined : 'presentation',
    alt: alt,
    loading: "lazy"
  }, filteredProps)));
}).withConfig({
  displayName: "StyledImage",
  componentId: "sc-1ugkyhf-0"
})(["", " ", ""], _ref3 => {
  let {
    stretch
  } = _ref3;
  return stretch && 'width: 100%;';
}, _ref4 => {
  let {
    stretch,
    ...props
  } = _ref4;
  return stretch && (0, _responsiveProps.responsiveCssProps)({
    props,
    propName: 'width',
    cssProperty: 'max-width',
    formatValues: v => `${v}px`
  });
});

/**
## Usage

```jsx
import { Image } from '@farewill/ui'
```

## Example

```jsx
<Image
  formatPath={({ path, ext, width }) => `${path}-${width}.${ext}`}
  path="/path/to/image"
  ext="jpg"
  width={400}
  widthFromM={600}
/>
```

Generated output:

```jsx
<picture>
  <source
    srcSet="/path/to/image-600.jpg 1x, /path/to/image-1200.jpg 2x"
    media="(min-width: 648px)"
  />
  <source srcSet="/path/to/image-400.jpg 1x, /path/to/image-800.jpg 2x" />
  <img src="/path/to/image-400.jpg" role="presentation" />
</picture>
```

## Notes

The `<Image>` component creates a `<picture>` element with relevent sources according to the responsive `width` prop. `width` describes the width of the requested asset, not the rendered width of the element. This should be the maximum width that the image will take up at each breakpoint.

`<Image>` expects a responsive `path` prop. By default it assumes images are stored in Cloudinary, so the `path` can be provided as a shorthand of `[folder]/[image name]`. If the image you want to use is hosted elsewhere, you can use the `formatPath` prop for finer control of the generated image paths.

*/
const Image = props => /*#__PURE__*/_react.default.createElement(StyledImage, props);
Image.defaultProps = DEFAULT_PROPS;
StyledImage.defaultProps = DEFAULT_PROPS;
var _default = exports.default = Image;